import './BeaconLoader.css';

interface BeaconLoaderProps {
  size?: number;
}

export function BeaconLoader({ size = 24 }: BeaconLoaderProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10.5" stroke="var(--color-primary-9)" strokeWidth="1.25" />
      <circle cx="12" cy="12" r="6.5" stroke="var(--color-text-1)" strokeWidth="1.25" opacity="0.85" />
      <circle
        className="beacon-ring"
        cx="12"
        cy="12"
        r="2"
        fill="none"
        stroke="var(--color-primary-9)"
        strokeWidth="0.75"
      />
      <circle className="beacon-dot" cx="12" cy="12" r="2" fill="var(--color-primary-9)" />
      <line x1="12" y1="0.5" x2="12" y2="4" stroke="var(--color-primary-9)" strokeWidth="1.25" />
      <line x1="12" y1="20" x2="12" y2="23.5" stroke="var(--color-primary-9)" strokeWidth="1.25" opacity="0.5" />
    </svg>
  );
}
